/**
 * Grape varieties (owner request, 2026-10-04): the Cépage is chosen from this list, several for a
 * blend, rather than typed. A variety the list lacks can be added; it then shows among the
 * choices because a wine uses it. A wine's Cépage is still stored as text, its varieties A to Z
 * joined by commas ("Grenache, Mourvèdre, Syrah"), so wines saved before keep theirs as written.
 * Names use the usual French spelling, or the variety's own where it is mostly known by it.
 */
import { grapeVarieties } from './filters';
import { normaliseIdentityField } from './identity';

export const GRAPES: readonly string[] = [
  // France
  'Aligoté',
  'Altesse',
  'Aramon',
  'Arbois',
  'Auxerrois',
  'Bourboulenc',
  'Cabernet franc',
  'Cabernet-Sauvignon',
  'Carignan',
  'Chardonnay',
  'Chasselas',
  'Chenin',
  'Cinsault',
  'Clairette',
  'Colombard',
  'Counoise',
  'Courbu',
  'Côt',
  'Duras',
  'Fer servadou',
  'Folle blanche',
  'Gamay',
  'Gewurztraminer',
  'Grenache',
  'Grenache blanc',
  'Grenache gris',
  'Gros manseng',
  'Jacquère',
  'Len de l’el',
  'Macabeu',
  'Malbec',
  'Marsanne',
  'Mauzac',
  'Melon de Bourgogne',
  'Merlot',
  'Meunier',
  'Mondeuse',
  'Mourvèdre',
  'Muscadelle',
  'Muscat',
  'Muscat à petits grains',
  'Muscat d’Alexandrie',
  'Négrette',
  'Petit manseng',
  'Petit verdot',
  'Picpoul',
  'Pinot blanc',
  'Pinot gris',
  'Pinot noir',
  'Poulsard',
  'Prunelard',
  'Riesling',
  'Rolle',
  'Roussanne',
  'Sauvignon blanc',
  'Sauvignon gris',
  'Savagnin',
  'Sciaccarellu',
  'Sémillon',
  'Syrah',
  'Sylvaner',
  'Tannat',
  'Terret',
  'Tibouren',
  'Trousseau',
  'Ugni blanc',
  'Vaccarèse',
  'Viognier',
  'Vermentino',
  // Italy
  'Aglianico',
  'Arneis',
  'Barbera',
  'Cannonau',
  'Corvina',
  'Cortese',
  'Dolcetto',
  'Falanghina',
  'Fiano',
  'Freisa',
  'Frappato',
  'Friulano',
  'Garganega',
  'Glera',
  'Greco',
  'Grillo',
  'Lagrein',
  'Lambrusco',
  'Malvasia',
  'Montepulciano',
  'Nebbiolo',
  'Negroamaro',
  'Nerello mascalese',
  'Nero d’Avola',
  'Pecorino',
  'Primitivo',
  'Refosco',
  'Ribolla gialla',
  'Rondinella',
  'Sagrantino',
  'Sangiovese',
  'Schiava',
  'Teroldego',
  'Trebbiano',
  'Verdicchio',
  'Vermentino nero',
  // Spain and Portugal
  'Albariño',
  'Alicante Bouschet',
  'Arinto',
  'Baga',
  'Bobal',
  'Castelão',
  'Encruzado',
  'Godello',
  'Graciano',
  'Loureiro',
  'Mencía',
  'Monastrell',
  'Palomino',
  'Parellada',
  'Pedro Ximénez',
  'Tempranillo',
  'Tinta barroca',
  'Tinta roriz',
  'Touriga franca',
  'Touriga nacional',
  'Trincadeira',
  'Verdejo',
  'Xarel·lo',
  // Germany, Austria, Switzerland and central Europe
  'Blaufränkisch',
  'Dornfelder',
  'Furmint',
  'Grüner Veltliner',
  'Hárslevelű',
  'Kerner',
  'Müller-Thurgau',
  'Petite Arvine',
  'Portugieser',
  'Scheurebe',
  'Sankt Laurent',
  'Trollinger',
  'Welschriesling',
  'Zweigelt',
  // Greece, eastern Mediterranean and beyond
  'Agiorgitiko',
  'Assyrtiko',
  'Feteasca neagra',
  'Mavrud',
  'Moschofilero',
  'Plavac mali',
  'Rkatsiteli',
  'Saperavi',
  'Xinomavro',
  // New World and crossings
  'Bonarda',
  'Carmenère',
  'Pinotage',
  'Petite Sirah',
  'Torrontés',
  'Zinfandel',
  'Chambourcin',
  'Norton',
  'Marselan',
  'Caladoc',
  'Muscat de Hambourg',
  'Muscat ottonel',
  'Gros plant',
  'Lledoner pelut',
  'Abouriou',
  'Petit courbu',
  'Arrufiac',
  'Camaralet',
  'Verdesse',
  'Persan',
  'Gringet',
  'Molette',
  'Ondenc',
  'Valdiguié',
  'Pinot d’Aunis',
  'Grolleau',
  'Romorantin',
  'Savagnin rose',
  'Klevener de Heiligenstein',
  // Added with the regional lists (owner request, 2026-10-08: domain/region-grapes.ts)
  'Aidani',
  'Airén',
  'Aladasturi',
  'Albana',
  'Albillo',
  'Aleksandrouli',
  'Alfrocheiro',
  'Amigne',
  'Antão Vaz',
  'Arbane',
  'Athiri',
  'Avesso',
  'Azal',
  'Babeasca neagra',
  'Babić',
  'Bacchus',
  'Baco noir',
  'Bianco gentile',
  'Bical',
  'Blauer Wildbacher',
  'Boal',
  'Bombino',
  'Bondola',
  'Bovale',
  'Brachetto',
  'Cagnulari',
  'Canaiolo',
  'Carricante',
  'Catarratto',
  'Caíño',
  'Chinuri',
  'Ciliegiolo',
  'Cococciola',
  'Coda di volpe',
  'Colorino',
  'Cornalin',
  'Corvinone',
  'César',
  'Códega do Larinho',
  'Debit',
  'Delaware',
  'Dimyat',
  'Domina',
  'Doña Blanca',
  'Durella',
  'Elbling',
  'Erbaluce',
  'Espadeiro',
  'Fernão Pires',
  'Feteasca alba',
  'Feteasca regala',
  'Frühburgunder',
  'Gamaret',
  'Garanoir',
  'Goruli Mtsvane',
  'Gouveio',
  'Grasa de Cotnari',
  'Grechetto',
  'Grignolino',
  'Grk',
  'Groppello',
  'Humagne rouge',
  'Insolia',
  'Jaen',
  'Johanniter',
  'Kabar',
  'Kadarka',
  'Khikhvi',
  'Kisi',
  'Koshu',
  'Kotsifali',
  'Krakhuna',
  'Kövérszőlő',
  'Lacrima',
  'Leányka',
  'Liatiko',
  'Limnio',
  'L’Acadie blanc',
  'Malagousia',
  'Mandilaria',
  'Maraština',
  'Maria Gomes',
  'Marquette',
  'Marzemino',
  'Maturana',
  'Mavrotragano',
  'Melnik',
  'Merwah',
  'Molinara',
  'Monica',
  'Moscatel roxo',
  'Mtsvane',
  'Mujuretuli',
  'Muscat Bailey A',
  'Negoska',
  'Nerello cappuccio',
  'Nero di Troia',
  'Neuburger',
  'Nielluccio',
  'Nosiola',
  'Nuragus',
  'Obaideh',
  'Ortega',
  'Otskhanuri Sapere',
  'Pamid',
  'Passerina',
  'País',
  'Pelaverga',
  'Perricone',
  'Petit meslier',
  'Picolit',
  'Piedirosso',
  'Pignoletto',
  'Pinela',
  'Pošip',
  'Rabigato',
  'Raboso',
  'Rara neagra',
  'Regent',
  'Reichensteiner',
  'Roditis',
  'Rondo',
  'Roupeiro',
  'Rubin',
  'Ruché',
  'Schioppettino',
  'Sercial',
  'Seyval blanc',
  'Shavkapito',
  'Solaris',
  'Sousão',
  'Souvignier gris',
  'Sumoll',
  'Susumaniello',
  'Tamaioasa romaneasca',
  'Tavkveri',
  'Tempranillo blanco',
  'Teran',
  'Terrantez',
  'Timorasso',
  'Tinta negra',
  'Tinto cão',
  'Treixadura',
  'Trepat',
  'Tsitska',
  'Tsolikouri',
  'Verdelho',
  'Verduzzo',
  'Vernaccia',
  'Vidal',
  'Vidiano',
  'Vilana',
  'Vinhão',
  'Viosinho',
  'Vital',
  'Zelen',
  'Zéta',
  'Žametovka',
];

const normalise = (name: string) => normaliseIdentityField(name);
const byName = (a: string, b: string) => a.localeCompare(b, 'fr', { sensitivity: 'base' });

/**
 * The Cépage choices for a cellar: the list, plus the varieties its wines use that the list lacks
 * (added by the person, or saved before the list existed), once each, A to Z.
 */
export function grapeChoices(wines: readonly { cepage: string }[]): string[] {
  const byKey = new Map(GRAPES.map((name) => [normalise(name), name]));
  for (const wine of wines) {
    for (const variety of grapeVarieties(wine.cepage)) {
      const key = normalise(variety);
      if (!byKey.has(key)) byKey.set(key, variety);
    }
  }
  return [...byKey.values()].sort(byName);
}

/**
 * A Cépage as stored: each variety spelled as among `known` when it is there (case and accents
 * aside), else as written; once each, A to Z, joined by commas. So the same blend always reads
 * the same, whatever order it was picked in.
 */
export function canonicalCepage(cepage: string, known: readonly string[]): string {
  const spelling = new Map(known.map((name) => [normalise(name), name]));
  const varieties = new Map<string, string>();
  for (const variety of grapeVarieties(cepage)) {
    const key = normalise(variety);
    if (!varieties.has(key)) varieties.set(key, spelling.get(key) ?? variety);
  }
  return [...varieties.values()].sort(byName).join(', ');
}
